import React from "react"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"
import StopIcon from "@material-ui/icons/Stop"
import useIsMounted from "../../lib/useIsMounted"

import { IconButton } from "@material-ui/core"

export default function BackgroundMusic({ sound, title }) {
  const [playing, setPlaying] = React.useState(false)
  const isMounted = useIsMounted()
  const backgroundMusic = React.useMemo(
    () => (isMounted ? new Audio(sound) : null),
    [isMounted, sound]
  )
  const playBackgroundMusic = evt => {
    if (playing) {
      backgroundMusic.pause()
      setPlaying(false)
    } else {
      backgroundMusic.play()
      setPlaying(true)
    }
  }
  return (
    <IconButton
      aria-label={"Musik " + (playing ? "an" : "aus")}
      style={{ color: "white" }}
      onClick={playBackgroundMusic}
      title={title}
    >
      {playing ? <StopIcon /> : <PlayCircleFilledIcon />}
    </IconButton>
  )
}
